import { render, staticRenderFns } from "./test-form-component.vue?vue&type=template&id=5ba62ac0&lang=html&"
import script from "./test-form-component.vue?vue&type=script&lang=js&"
export * from "./test-form-component.vue?vue&type=script&lang=js&"
import style0 from "./test-form-component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports